module.exports = __webpack_public_path__ + "img/pg5-inner-title.2c5ee028.png";